const initialState = {
    tempFiles: [],
    cancelToken: null,
    showModal: false,
    showFileListModal: false,
    uploadComplete: null,
}

export default function reducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case "FILEUPLOAD_TOGGLE_UPLOAD_MODAL":
            return {
                ...state,
                showModal: !state.showModal
            }

        case "FILEUPLOAD_DISPLAY_UPLOAD_MODAL":
            return {
                ...state,
                showModal: action.showModal
            }

        case "FILEUPLOAD_TOGGLE_UPLOAD_LIST_MODAL":
            return {
                ...state,
                showFileListModal: !state.showFileListModal
            }
            
        case "FILEUPLOAD_DISPLAY_UPLOAD_LIST_MODAL":
            return {
                ...state,
                showFileListModal: action.showFileListModal
            }

        case "FILEUPLOAD_UPDATE_TEMP_FILES":
            let currentTempFiles = [...state.tempFiles];

            for(const item of action.tempFiles) {
                const updateIndex = _.findIndex(currentTempFiles, { id: item.id });

                if(updateIndex >= 0) {
                    currentTempFiles.splice(updateIndex, 1, {...currentTempFiles[updateIndex], ...item});
                } else {
                    currentTempFiles.push(item);
                }
            }

            return {
                ...state,
                tempFiles: currentTempFiles
            }

        case "FILEUPLOAD_CLEAR_TEMP_FILES":
            return {
                ...state,
                tempFiles: []
            }

        case "FILEUPLOAD_UPDATE_CANCEL_TOKEN":
            return {
                ...state,
                cancelToken: action.cancelToken,
            }

        case "FILEUPLOAD_CLEAR_CANCEL_TOKEN":
            return {
                ...state,
                cancelToken: null,
            }

        case "FILEUPLOAD_UPDATE_COMPLETED_FLAG":
            return {
                ...state,
                uploadComplete: action.uploadComplete,
            }

        case "FILEUPLOAD_CANCELE_TEMP_FILE":
            return {
                ...state,
                tempFiles: state.tempFiles.filter(f => f.id !== action.fileId)
            }

        case "FILEUPLOAD_TOGGLE_TEMP_FILES_CHECKED_ALL":
            return {
                ...state,
                tempFiles: state.tempFiles.map(f => ({...f, isChecked: action.isChecked})),
            }
        
        case "FILEUPLOAD_RESET": 
            return {
                ...initialState
            }

        default:
            return state;
    }
}
